export default __webpack_public_path__ + "static/media/process-step1.9829ada9.svg";